// WIP: ask @design-team to provide color names and refactor
export const cFFFFFF = '#FFFFFF';
export const c000000 = '#000000';
export const c07071D = '#07071D';
// WIP: change #080820 to be #080822 (ref: @Aivars-K)
export const c080820 = '#080820';
export const c333353 = '#333353';

export const c14142E = '#14142E';
export const c1D1D37 = '#1D1D37';
export const c161634 = '#161634';
export const cED15FF = '#ED15FF';
export const cCC38FF = '#CC38FF';
export const c1F1F3A = '#1F1F3A';
export const c7239C4 = '#7239C4'; // probably all changed to #7A35CB
export const c7A35CB = '#7A35CB';
export const c13132E = '#13132E';
export const cEA135E = '#EA135E';
export const cFF005C = '#FF005C';
export const cAC004E = '#AC004E';
export const c82044C = '#82044C';
export const c00EE91 = '#00EE91';
export const c56EA99 = '#56EA99';
export const c00A06E = '#00A06E';
export const c185959 = '#185959';
export const c2A2A4D = '#2A2A4D';
export const c1A1A3D = '#1A1A3D';
export const cD9D9D9 = '#D9D9D9';
export const c0B0B20 = '#0B0B20';
export const c211A3C = '#211A3C';
export const c040E25 = '#040E25';
export const c040014 = '#040014';
export const c6D7278 = '#6D7278';
export const cBC44FF = '#BC44FF';
export const cFA9400 = '#FA9400';
export const cA568FE = '#A568FE';
export const cF1E20D = '#F1E20D';
export const gradientA = `linear-gradient(90deg, #7239C4 0%, #CC38FF 100%)`;

export const mainGridGapColor = c1D1D37;
